import React from 'react'
import styled from '@emotion/styled'
import {css} from '@emotion/core'

import {FormattedMessageWrapper} from '@daedalus/core/src/localization/components/FormattedMessage'

import Button from '../../../designSystem/Button'
import {
  ShowPasswordlessLoginPayload,
  SourceComponentType,
  TrackUserSignInClickSourceComponent,
  AuthenticationFlows
} from '@daedalus/core/src/auth/types/Auth'
import {useDispatch} from 'react-redux'
import {
  trackLoginClick,
  trackSignUpClick,
  trackUserSignInClick
} from '@daedalus/core/src/auth/modules/actions'

const Separator = styled('span')(
  ({theme}) => css`
    width: 1px;
    height: 24px;
    background: ${theme.colors.inputBorder};
    display: inline-block;
  `
)

const ButtonsWrapper = styled('div')(
  () => css`
    display: flex;
    align-items: center;
  `
)

type PropsType = {
  /** The click handler */
  onSignIn: ({
    sourceComponent,
    flow
  }: {
    sourceComponent: ShowPasswordlessLoginPayload['sourceComponent']
    flow: ShowPasswordlessLoginPayload['flow']
  }) => void
}

const SignInButton = ({onSignIn}: PropsType) => {
  const dispatch = useDispatch()
  const component = SourceComponentType.Header

  const handleOnSingUpClick = () => {
    dispatch(
      trackUserSignInClick(TrackUserSignInClickSourceComponent.UserWidgetSignUp)
    )
    dispatch(trackSignUpClick(component))

    onSignIn({
      sourceComponent: component,
      flow: AuthenticationFlows.SignUp
    })
  }

  const handleOnLoginClick = () => {
    dispatch(
      trackUserSignInClick(TrackUserSignInClickSourceComponent.UserWidgetSignIn)
    )
    dispatch(trackLoginClick(component))
    onSignIn({
      sourceComponent: component,
      flow: AuthenticationFlows.Login
    })
  }

  return (
    <ButtonsWrapper>
      <Button
        appearance="quiet"
        dataId="SignUpButton"
        onClick={handleOnSingUpClick}
      >
        <FormattedMessageWrapper id="signUpCTA" defaultMessage="Sign up" />
      </Button>
      <Separator />
      <Button
        appearance="quiet"
        dataId="LogInButton"
        onClick={handleOnLoginClick}
      >
        <FormattedMessageWrapper id="logInCTA" defaultMessage="Log in" />
      </Button>
    </ButtonsWrapper>
  )
}

export default SignInButton
